module.exports = __webpack_public_path__ + "img/list-white.5f279680.svg";